export class QueryParamStorageService {
    constructor(private storageKeyPrefix: string = 'der-tm:') {}

    public captureAndStore(
        paramsToTrack: string[],
        toSession: boolean = false,
        ttl: string = '14d'
    ): Record<string, string> {
        const urlParams = new URLSearchParams(window.location.search);
        const storedData: Record<string, string> = {};
        const storage = toSession ? sessionStorage : localStorage;

        // if toSession is true and at least one of the paramsToTrack is present in the URL, we clear the storage for those params
        if (toSession && paramsToTrack.some((param) => urlParams.get(param) !== null)) {
            paramsToTrack.forEach((param) => storage.removeItem(`${this.storageKeyPrefix}${param}`));
        }

        if (!toSession) {
            this.handleTtl(storage, paramsToTrack, urlParams, ttl);
        }

        paramsToTrack.forEach((param) => {
            const value = urlParams.get(param);
            const key = `${this.storageKeyPrefix}${param}`;

            if (value !== null) {
                storage.setItem(key, value);
                storedData[param] = value;
            } else {
                const cachedValue = storage.getItem(key);
                if (cachedValue) storedData[param] = cachedValue;
            }
        });

        return storedData;
    }

    private handleTtl(storage: Storage, paramsToTrack: string[], urlParams: URLSearchParams, ttl: string): void {
        const ttlKey = `${this.storageKeyPrefix}facet-ttl`;
        const expiry = storage.getItem(ttlKey);

        if (expiry && Date.now() >= new Date(expiry).getTime()) {
            paramsToTrack.forEach((param) => storage.removeItem(`${this.storageKeyPrefix}${param}`));
            storage.removeItem(ttlKey);
        }

        if (paramsToTrack.some((param) => urlParams.get(param) !== null)) {
            storage.setItem(ttlKey, new Date(Date.now() + this.parseTtl(ttl)).toISOString());
        }
    }

    private parseTtl(ttl: string): number {
        const match = /^(\d+)([mhd])$/.exec(ttl);
        if (!match) return this.parseTtl('14d');

        const unitMs: Record<string, number> = { m: 60_000, h: 3_600_000, d: 86_400_000 };
        return Number(match[1]) * unitMs[match[2]];
    }
}
